import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Button, Form } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect } from "react";
import { Media, Message } from "../../../js/parsegenerated";
import { MessageFormItems, MessageValueType } from "./MessageFormItems";

type FormValues = {
  message: MessageValueType;
};

type Props = {
  onSave?: () => void;
  onError?: () => void;
} & (
  | {
      referencedObject: string;
      className: string;
      message?: never;
    }
  | {
      referencedObject?: never;
      className?: never;
      message: Message;
    }
);

export const MessageForm = observer((props: Props) => {
  const t = useTranslation();
  const [form] = Form.useForm<FormValues>();
  const { notification } = useFeedback();
  const [saving, setSaving] = React.useState(false);

  useEffect(() => {
    async function fillForm() {
      if (props.message) {
        // get the media from the message
        const media = await props.message.relation("media").query().find();

        form.setFieldsValue({
          message: {
            title: props.message.get("title"),
            description: props.message.get("content"),
            media: media,
            date: dayjs(props.message.get("displayAt")),
          },
        });
      }
    }

    fillForm();
  }, [props.message]);

  async function handleSaveMessage(values: FormValues) {
    const { message } = values;
    setSaving(true);

    try {
      console.log(message.media);

      const savedMessage = await new Message({
        referencedObjectId: props.referencedObject,
        classname: props.className,
        title: message.title,
        content: message.description,
        data: { type: "userinput" },
        displayAt: message.date?.toDate(),
        user: Parse.User.current(),
        tenant: Parse.User.current().get("tenant"),
      }).save();

      if (message.media && message.media.length > 0) {
        const media = await Media.saveAll(message.media);
        savedMessage.relation("media").add(media);
      }

      await savedMessage.save();

      props.onSave?.();
      notification.success({
        message: t("maintenance:message.create.success"),
      });
    } catch (e) {
      console.error(e);
      props.onError?.();
      notification.error({
        message: t("maintenance:message.create.error"),
      });
    }

    setSaving(false);
  }

  return (
    <Form onFinish={handleSaveMessage} layout="vertical" form={form}>
      <MessageFormItems name="message" />
      <Button htmlType="submit" loading={saving}>
        {t("maintenance:global.button.save_label")}
      </Button>
    </Form>
  );
});
